import { usePermission } from "../hooks/usePermission";
import { Route, Redirect, useHistory } from 'react-router-dom';
import { Button, Result } from "antd";

/** A page without the permission: signed-in users see it is not for them (they were sent to the login, as signed out) */
const Forbidden = () => {
    const history = useHistory();
    return (
        <Result
            status="403"
            title="Non hai accesso a questa pagina"
            subTitle="Il tuo profilo non ha i permessi per aprirla. Se ti serve, chiedi all'amministratore."
            extra={<Button type="primary" onClick={() => (window.history.length > 1 ? history.goBack() : history.push("/"))}>Torna indietro</Button>}
        />
    );
};

export const ProtectedRoute = ({ permission, roles, children, ...rest }) => {
    const { canOpen } = usePermission();

    const handleRouteRender = () => ({ location }) => {
        if (canOpen(permission, roles)) {
          return children;
        }
        if (localStorage.getItem("auth")) {
          return <Forbidden />;
        }

        return <Redirect to="/login" state={{ from: location }} />;
    };
  
    return (
        <Route
            {...rest}
            render={handleRouteRender()}
        />
    );
};
